import ColumnLayout from '@cloudscape-design/components/column-layout';
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { FOUNDERS } from '../content.js';

/**
 * Founders — humanises the pitch. Two cards, real names and titles, real
 * credentials. Photo placeholder is an initial-avatar so the layout does
 * not shift when photos land later.
 */
export function Founders(): ReactNode {
  return (
    <MarketingContainer paddingY="default" id="founders">
      <SpaceBetween size="xl">
        <SectionHeader
          eyebrow="Who's building this"
          headline={FOUNDERS.headline}
          subhead={FOUNDERS.subhead}
        />
        <ColumnLayout columns={2} variant="text-grid">
          {FOUNDERS.founders.map((f) => (
            <Container key={f.name}>
              <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
                <FounderAvatar name={f.name} photoUrl={f.photoUrl} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 18, fontWeight: 700 }}>{f.name}</div>
                  <div style={{ color: '#6366f1', fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                    {f.title}
                  </div>
                  <div style={{ color: '#475569', lineHeight: 1.6 }}>{f.bio}</div>
                </div>
              </div>
            </Container>
          ))}
        </ColumnLayout>
      </SpaceBetween>
    </MarketingContainer>
  );
}

function FounderAvatar({
  name,
  photoUrl,
}: {
  name: string;
  photoUrl: string | null;
}): ReactNode {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
    );
  }
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <div
      style={{
        width: 72,
        height: 72,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #818cf8, #a855f7)',
        color: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: 24,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}
